import { useState } from 'react'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import OutsideAlerter from '../../hooks/useOutsideClick'
import Icon from '../Icon'
import theme from '../../theme/cheddar'
import style from '../../styles/components/story/embed-modal'

const EmbedCodeModal = ({ story, closeModal, showModal }) => {
  const [buttonText, setButtonText] = useState('Copy Code')
  const embedCode = `<iframe src='https://cheddar.com/media/${story.slug}/player?autoplay=false' width='560' height='315' frameborder='0' allowfullscreen></iframe>`

  const copyEmbedCode = () => {
    navigator.clipboard.writeText(embedCode)
    setButtonText('Copied')
  }

  const closeModalHandler = () => {
    closeModal()
    setButtonText('Copy Code')
  }

  return (
    <>
      <OutsideAlerter onClickOutside={closeModalHandler}>
        <div className={`embed-container ${showModal ? 'visible' : ''}`} data-testid='modal'>
          <div onClick={closeModalHandler} className='close-button' title='Close'>
            <Icon icon={faClose} size={'xl'} color={theme.colors.grey} />
          </div>
          <div className='content'>
            <div className='title'>Embed</div>
            <textarea disabled value={embedCode} />
            <button className='submit-button' onClick={copyEmbedCode}>
              {buttonText}
            </button>
          </div>
        </div>
      </OutsideAlerter>
      <style jsx>{style}</style>
    </>
  )
}

export default EmbedCodeModal
